/* eslint-disable react/display-name */
/* eslint-disable linebreak-style */
import {takeLatest, put, all, call} from 'redux-saga/effects';
import {
  LOAD_PRODUSE_START,
  LOAD_MATERIALE_START,
  LOAD_PRETURITABELARE_START,
  LOAD_OPTIONALE_START,
  LOAD_CULORI_START,
  LOAD_INFORMARI_START,
  LOAD_INDICATORI_START,
  LOAD_FIRMA_START,
  LOAD_FIRME_COMISIONAR_START,
  LOAD_CURS_START,
} from './lookup.actions.types'
import {loadProduseSuccess,loadMaterialeSuccess,loadOptionaleSuccess, loadCuloriSuccess,loadPreturiTabelareSuccess, loadPreturiTabelareFailure, loadInformariSuccess, loadIndicatoriSuccess, loadFirmaSuccess, loadFirmeComisionarSuccess, loadFirmeComisionarFailure, loadCursSuccess } from './lookup.actions';
import {enqueueSnackbar, setLoading, setDone} from '../other/other.actions';
import {strapi} from '../../strapi/strapi.config';
import {comparaIndicatori} from '../../strapi/strapi.utils';
import {LOOKUP_CACHE_KEYS, getLookupCache, setLookupCache} from '../../storage/lookupCacheStorage';


export function* getProduse(){
  try{
    console.log('Saga Produse: Începe încărcarea');
    const egalitateIndicator = yield comparaIndicatori('produse')
     
    if(egalitateIndicator){
      console.log('Saga Produse: Folosim date din cache');
      const produseDinCache = yield call(getLookupCache, LOOKUP_CACHE_KEYS.PRODUSE);
      yield put(loadProduseSuccess(produseDinCache || [])) 
    } else {
      console.log('Saga Produse: Încărcare de la server');
      const produse = yield strapi.getEntries('produses', {_limit:10000})
      yield put(loadProduseSuccess(produse))
      yield call(setLookupCache, LOOKUP_CACHE_KEYS.PRODUSE, produse)
    }
    console.log('Saga Produse: Încărcare completă');
  } catch(error){ 
    console.error('Saga Produse: Eroare', error);
  }
}

export function* getMateriale(){
  try{
    console.log('Saga Materiale: Începe încărcarea');
    const egalitateIndicator = yield comparaIndicatori('materiale')
     
    if(egalitateIndicator){
      console.log('Saga Materiale: Folosim date din cache');
      const materialeDinCache = yield call(getLookupCache, LOOKUP_CACHE_KEYS.MATERIALE);
      yield put(loadMaterialeSuccess(materialeDinCache || []))
    } else {
      console.log('Saga Materiale: Încărcare de la server');
      const materiale = yield strapi.getEntries('materials',{_limit:10000, _sort:'denumire:ASC'})
      yield put(loadMaterialeSuccess(materiale))
      yield call(setLookupCache, LOOKUP_CACHE_KEYS.MATERIALE, materiale)
    }
    console.log('Saga Materiale: Încărcare completă');
  } catch(error){ 
    console.error('Saga Materiale: Eroare', error);
  }
}

export function* getOptionale(){
  try{
    console.log('Saga Optionale: Începe încărcarea');
    const egalitateIndicator = yield comparaIndicatori('optionale')
     
    if(egalitateIndicator){
      console.log('Saga Optionale: Folosim date din cache');
      const optionaleDinCache = yield call(getLookupCache, LOOKUP_CACHE_KEYS.OPTIONALE);
      yield put(loadOptionaleSuccess(optionaleDinCache || []))
    } else {
      console.log('Saga Optionale: Încărcare de la server');
      const optionale = yield strapi.getEntries('optionals',{_limit:10000, _sort:'denumire:ASC',tipProdus_in:['JV','JO']})
      yield put(loadOptionaleSuccess(optionale))
      yield call(setLookupCache, LOOKUP_CACHE_KEYS.OPTIONALE, optionale)
    }
    console.log('Saga Optionale: Încărcare completă');
  } catch(error){ 
    console.error('Saga Optionale: Eroare', error);
  }
}

export function* getCulori(){
  try{
    console.log('Saga Culori: Începe încărcarea');
    const egalitateIndicator = yield comparaIndicatori('culori')
     
    if(egalitateIndicator){
      console.log('Saga Culori: Folosim date din cache');
      const culoriDinCache = yield call(getLookupCache, LOOKUP_CACHE_KEYS.CULORI);
      yield put(loadCuloriSuccess(culoriDinCache || []))
    } else {
      console.log('Saga Culori: Încărcare de la server');
      const culori = yield strapi.getEntries('culoares',{tipProdus:'JO',_limit:10000, _sort:'codCuloare:ASC'})
      yield put(loadCuloriSuccess(culori))
      yield call(setLookupCache, LOOKUP_CACHE_KEYS.CULORI, culori)
    }
    console.log('Saga Culori: Încărcare completă');
  } catch(error){ 
    console.error('Saga Culori: Eroare', error);
  }
}

export function* getPreturiTabelare(){
  try{
    console.log('Saga PreturiTabelare: Începe încărcarea');
    let egalitateIndicator = false;
    try {
      egalitateIndicator = yield comparaIndicatori('preturitabelare');
      console.log('Saga PreturiTabelare: Rezultat comparare indicatori:', egalitateIndicator);
    } catch (error) {
      console.error('Saga PreturiTabelare: Eroare la comparare indicatori:', error);
    }
     
    if(egalitateIndicator){
      console.log('Saga PreturiTabelare: Folosim date din cache');
      const dateDinCache = yield call(getLookupCache, LOOKUP_CACHE_KEYS.PRETURI_TABELARE);
      console.log('Saga PreturiTabelare: Date din cache:', {
        existaDate: !!dateDinCache,
        numarInregistrari: dateDinCache?.length
      });
      if (!dateDinCache) {
        console.log('Saga PreturiTabelare: Cache invalid, încercăm de la server');
        throw new Error('Cache invalid');
      }
      yield put(loadPreturiTabelareSuccess(dateDinCache))
    } else {
      console.log('Saga PreturiTabelare: Încărcare de la server');
      const preturitabelare = yield strapi.getEntries('prettabelars', {
        _limit: 100000,
        _sort: 'id:ASC'
      });
      
      console.log('Saga PreturiTabelare: Răspuns API:', {
        existaDate: !!preturitabelare,
        numarInregistrari: preturitabelare?.length
      });
      
      if (!preturitabelare || !Array.isArray(preturitabelare)) {
        throw new Error('Date invalide de la API');
      }

      if (preturitabelare.length === 0) {
        throw new Error('API-ul a returnat un array gol');
      }

      console.log('Saga PreturiTabelare: Încercare salvare în cache local');
      try {
        yield call(setLookupCache, LOOKUP_CACHE_KEYS.PRETURI_TABELARE, preturitabelare);
        console.log('Saga PreturiTabelare: Salvare în cache local reușită');
      } catch (storageError) {
        console.error('Saga PreturiTabelare: Eroare la salvare în cache local:', storageError);
      }

      console.log('Saga PreturiTabelare: Dispatch action SUCCESS');
      yield put(loadPreturiTabelareSuccess(preturitabelare));
    }
    console.log('Saga PreturiTabelare: Încărcare completă');
  } catch(error){ 
    console.error('Saga PreturiTabelare: Eroare:', error);
    yield put(loadPreturiTabelareFailure(error.message));
    yield put(enqueueSnackbar({
      message: `Eroare la încărcarea prețurilor: ${error.message}`,
      options: {
        key: 'preturi-error',
        variant: 'error',
        persist: true
      },
    }));
  }
}

export function* getInformari(){
  try{
    console.log('Saga Informari: Începe încărcarea');
    const egalitateIndicator = yield comparaIndicatori('informari')
     
    if(egalitateIndicator){
      console.log('Saga Informari: Folosim date din cache');
      const informariDinCache = yield call(getLookupCache, LOOKUP_CACHE_KEYS.INFORMARI);
      yield put(loadInformariSuccess(informariDinCache || []))
    } else {
      console.log('Saga Informari: Încărcare de la server');
      const informari = yield strapi.getEntries('informares',{_limit:10000})
      yield put(loadInformariSuccess(informari))
      yield call(setLookupCache, LOOKUP_CACHE_KEYS.INFORMARI, informari)
    }
    console.log('Saga Informari: Încărcare completă');
  } catch(error){ 
    console.error('Saga Informari: Eroare', error);
  }
}


export function* getIndicatori(){
  
  try{
    yield put(setLoading(true))
    const indicatori= yield strapi.getEntries('Indicators',{_limit:10000})
    yield put(loadIndicatoriSuccess(indicatori))
    yield call(setLookupCache, LOOKUP_CACHE_KEYS.INDICATORI, indicatori)
    yield put(setDone(true))
    yield put(setLoading(false))
  }catch(error){
    yield put(setLoading(false)) 
    yield put(enqueueSnackbar({
      message: `Va rugam sa va reautentificati. Eroare : nu am putut prelua nomenclatoarele.(${error})`,
      options: {
        key: null,
        variant: 'error',
      },
    },15000))
  }
}

export function* getFirma({payload:id}){
  try{
    console.log('Saga Firma: Începe încărcarea');
    const firma = yield strapi.getEntries('firmas',{id})
    yield put(loadFirmaSuccess(firma))
    yield call(setLookupCache, LOOKUP_CACHE_KEYS.FIRMA, firma)
    console.log('Saga Firma: Încărcare completă');
  } catch(error){ 
    console.error('Saga Firma: Eroare', error);
  }
}

export function* getFirmeComisionar({payload:idFirmaComisionar}){
  try{
    const firmaLogata = yield strapi.getEntries('firmas',{id:idFirmaComisionar})
    const firmasAfiliate = firmaLogata && firmaLogata[0] && Array.isArray(firmaLogata[0].firmas) ? firmaLogata[0].firmas : []
    let firme = []

    if (firmasAfiliate.length > 0 && typeof firmasAfiliate[0] === 'object') {
      firme = firmasAfiliate
    } else if (firmasAfiliate.length > 0) {
      firme = yield strapi.getEntries('firmas',{id_in: firmasAfiliate, _limit: 10000, _sort:'denumire:ASC'})
    }

    const firmeSortate = (firme || [])
      .filter(firma => firma && firma.id)
      .sort((a,b)=> String(a.denumire || '').localeCompare(String(b.denumire || '')))

    yield put(loadFirmeComisionarSuccess(firmeSortate))
  }catch(error){
    yield put(loadFirmeComisionarFailure(error))
    yield put(enqueueSnackbar({
      message: `Eroare : nu am putut prelua lista clientilor comisionarului.(${error})`,
      options: {
        key: null,
        variant: 'error',
      },
    }, 5000))
  }
}

export function* getCurs(){
  try{
    console.log('Saga Curs: Începe încărcarea');
    const endpoint = process.env.REACT_APP_BNR_ENDPOINT || 'https://larexirwebstore.com/bnr-eur'
    const raspuns = yield fetch(endpoint)
    if(!raspuns.ok){
      throw new Error(`HTTP ${raspuns.status}`)
    }
    const data = yield raspuns.json()
    const curs = Number(data?.eur)
    if(!Number.isFinite(curs)){
      throw new Error('Raspuns invalid pentru curs EUR')
    }
    yield put(loadCursSuccess(curs))
    console.log('Saga Curs: Încărcare completă');
  } catch(error){ 
    console.error('Saga Curs: Eroare', error);
    yield put(enqueueSnackbar({
      message: `Eroare : nu am putut prelua cursul valutar.(${error})`,
      options: {
        key: null,
        variant: 'error',
      },
    }, 15000))
  }
}


export function* onLoadProduseStart(){
  yield takeLatest (LOAD_PRODUSE_START,getProduse)
}

export function* onLoadMaterialeStart(){
  yield takeLatest (LOAD_MATERIALE_START,getMateriale)
}

export function* onLoadOptionaleStart(){
  yield takeLatest (LOAD_OPTIONALE_START,getOptionale)
}

export function* onLoadCuloriStart(){
  yield takeLatest (LOAD_CULORI_START,getCulori)
}

export function* onLoadPreturiTabelareStart(){
  yield takeLatest (LOAD_PRETURITABELARE_START,getPreturiTabelare)
}

export function* onLoadInformariStart(){
  yield takeLatest (LOAD_INFORMARI_START,getInformari)
}

export function* onLoadIndicatoriStart(){
  yield takeLatest (LOAD_INDICATORI_START,getIndicatori)
}
export function* onLoadFirmaStart(){
  yield takeLatest (LOAD_FIRMA_START,getFirma)
}

export function* onLoadFirmeComisionarStart(){
  yield takeLatest (LOAD_FIRME_COMISIONAR_START,getFirmeComisionar)
}

export function* onLoadCursStart(){
  yield takeLatest (LOAD_CURS_START,getCurs)
}


export function* lookupSagas(){
  yield all([
    call(onLoadProduseStart),
    call(onLoadMaterialeStart),
    call(onLoadOptionaleStart),
    call(onLoadCuloriStart),
    call(onLoadPreturiTabelareStart),
    call(onLoadInformariStart),
    call(onLoadFirmaStart),
    call(onLoadFirmeComisionarStart),
    call(onLoadCursStart),
    call(onLoadIndicatoriStart),
  ])
}


